import { DOMOutputSpecArray, Node, NodeSpec } from 'prosemirror-model';

import { RtSchemaType } from '../../editor/types';
import { NodeName } from '../../schema/nodes';

export class DocNode implements NodeSpec {
  public static readonly nodeName = NodeName.Doc;
  public static is(node: Node) {
    return node.type.name === DocNode.nodeName;
  }
  public content = 'block+';
}

export class TextNode implements NodeSpec {
  public static readonly nodeName = NodeName.Text;
  public static is(node: Node) {
    return node.type.name === TextNode.nodeName;
  }
  public group = 'inline';
}

export class ParagraphNode implements NodeSpec {
  public static readonly nodeName = NodeName.Paragraph;
  public static is(node: Node) {
    return node.type.name === ParagraphNode.nodeName;
  }
  public content = 'inline*';
  public group = 'block';
  public parseDOM = [{ tag: 'p' }];
  public toDOM = (): DOMOutputSpecArray => ['p', 0];
}

export class HardBreakNode implements NodeSpec {
  public static readonly nodeName = NodeName.HardBreak;
  public static is(node: Node) {
    return node.type.name === HardBreakNode.nodeName;
  }
  public inline = true;
  public group = 'inline';
  public selectable = false;
  public parseDOM = [{ tag: 'br' }];
  public toDOM = (): DOMOutputSpecArray => ['br'];
}

export type BasicPluginSchema = RtSchemaType<
  typeof DocNode | typeof TextNode | typeof ParagraphNode | typeof HardBreakNode
>;
